import scriptjs from 'scriptjs';
import {autobind} from 'core-decorators';
import {getDOMNode, getDOMNodes} from 'utils';
import BaseAdapter from './base';

export const loadScript = scriptjs;

// https://developers.panopto.com/scripts/embedapi.min.js

@autobind
export default class PanoptoAdapter extends BaseAdapter {
    apiUrls = {
        player: 'https://developers.panopto.com/scripts/embedapi.min.js',
    }

    static findVideos() {
        const nodes_div = getDOMNodes('div[src*="panopto"]');

        if (nodes_div.length == 0){
            return []

        }else{

            const placeholder_div = document.getElementById('video').firstChild;
            const atts = placeholder_div.attributes;

            window.embedApi = new EmbedApi("video", {
                width: atts['width'].value,
                height: atts['height'].value,
                //This is the URL of your Panopto site
                serverName: atts['data-panopto-host'].value.concat(".hosted.panopto.com"),
                sessionId: atts['data-video-id'].value
            });

            const panopto_iframe = document.getElementsByTagName('iframe')[0];
            for (var i = 0; i< atts.length; i++){
                if (atts[i].name != 'src'){
                    panopto_iframe.setAttribute(atts[i].name, atts[i].value)
                }
                placeholder_div.remove()
            }

            window.embedApi.loadVideo();

            const nodes = getDOMNodes('iframe[src*="hosted.panopto.com/Panopto"]');
            return nodes.map(iframe => ({
                provider: 'Panopto',
                videoId: iframe.src.match(/id=([\w-]+)/)[1],
                videoNode: iframe,
            }));
        }
    }

    loadAPI() {
        return new Promise((resolve, reject) => {
            let loading = true
            const check = () => {
                if (window.PanoptoSource) resolve();
                else if (loading) setTimeout(check, BaseAdapter.CHECK_INTERVAL);
            };

            check();

            const timeout = () => {
                loading = false
                reject('Panopto Player API failed to load');
            }
            setTimeout(timeout, BaseAdapter.API_TIMEOUT);
        });
    }

    attach() {
        window.embedApi.onStateChange = this.handleStateChange;
        window.embedApi.onReady = this.onPanoptoVideoReady;
    }

    onPanoptoVideoReady(){
        window.embedApi.disableCaptions();
    }

    handleStateChange(state) {
        if (this.isPlaying()) this.syncPlayhead();
    }

    syncPlayhead() {
        const syncInterval = 200;
        const currentTime = this.getCurrentTime();
        this.setPlayhead(currentTime);
        setTimeout(this.syncPlayhead, syncInterval);
    }

    seek(time) {
        window.embedApi.seekTo(this.toSS(time));
    }

    isPlaying() {
        return !window.embedApi.getIsPaused();
    }

    pause() {
        window.embedApi.pauseVideo();
    }

    getDuration() {
        return this.toMS(window.embedApi.getDuration());
    }

    getCurrentTime() {
        return this.toMS(window.embedApi.getCurrentTime())
    }

    getVideoTitle() {
        return new Promise(resolve => resolve(''));
    }
}



// WEBPACK FOOTER //
// ./scripts/adapters/panopto.js